<template>
  <div>
    <v-row justify="end">
      <v-col cols="12" sm="6" lg="8" xl="9" align="start">
        <v-card-title class="pl-0 pt-0">{{ labelComputed }}</v-card-title>
      </v-col>
      <v-col cols="12" sm="6" lg="4" xl="3" align="end">
        <v-btn
          v-if="!readonly && !disabled"
          block
          outlined
          color="primary"
          @click="$emit('addRecipient')"
        >
          Add Recipient
          <v-icon right>add</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <EmailRecipientInput
          v-for="(recipient, index) in recipientsList"
          :key="index"
          :id="index"
          :name="recipient.name"
          :emailAddress="recipient.emailAddress"
          :notes="recipient.notes"
          :readonly="readonly"
          :disabled="disabled"
          :showDeleteButton="!readonly && !disabled"
          :showNotes="showNotes"
          @nameChange="(id, newValue) => $emit('nameChange', id, newValue)"
          @emailChange="(id, newValue) => $emit('emailChange', id, newValue)"
          @notesChange="(id, newValue) => $emit('notesChange', id, newValue)"
          @deleteRecipient="(id) => $emit('deleteRecipient', id)"
        ></EmailRecipientInput>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { EmailRecipientInput } from '@/components/emails/index'

export default {
  props: [
    'label',
    'recipientsList',
    'readonly',
    'disabled',
    'showNotes'
  ],
  computed: {
    labelComputed: {
      get () {
        return this.label ? this.label : 'Recipients'
      }
    }
  },
  components: {
    EmailRecipientInput
  }
}
</script>
